import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#disabled" }),
  /*#__PURE__*/_createTextVNode(" Disabled ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("code", null, "disabled"),
  /*#__PURE__*/_createTextVNode(" attribute is used to disable the radio. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Option A")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Option B")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_radio, {
        disabled: "",
        modelValue: _ctx.radio,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radio = $event)),
        label: "disabled"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_radio, {
        disabled: "",
        modelValue: _ctx.radio,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.radio = $event)),
        label: "selected and disabled"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}